import { message } from 'antd';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { addUpdateExamCodeAPI, fetchExamCodesRequestAPI } from '../../../services/examCodes-service';
import { HIDE_MODAL, SUBMIT_ERROR, SUBMIT_START } from '../../actions/admin/modalActions';
import { ADD_UPDATE_EXAMCODE, ADD_UPDATE_EXAMCODE_SUCCESS, FETCH_ALL_EXAMCODES, FETCH_ALL_EXAMCODES_ERROR, FETCH_ALL_EXAMCODES_START, FETCH_ALL_EXAMCODES_SUCCESS, SET_ALL_EXAMCODES_PAGINATION } from '../../actions/admin/examCodesActions';

function* fetchAllExamCodes({ payload }) {
    try {
        yield put({
            type: FETCH_ALL_EXAMCODES_START
        })
        const response = yield fetchExamCodesRequestAPI(payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({type: FETCH_ALL_EXAMCODES_SUCCESS,data: response.data});
            yield put({ type: SET_ALL_EXAMCODES_PAGINATION, pagination });          
        } else {
            yield put({ type: FETCH_ALL_EXAMCODES_ERROR })
            message.error('Failed to fetch exam codes!');
        }
    } catch (error) {
        yield put({ type: FETCH_ALL_EXAMCODES_ERROR, error })
        message.error('Failed to fetch exam codes!');
    }
}
function* addUpdateExamCode({ payload }) {
    try {
        yield put({ type: SUBMIT_START });
        const response = yield call(addUpdateExamCodeAPI, payload);
        if (response.success) {
            yield put({
                type: HIDE_MODAL,
            })
            yield put({
                type: ADD_UPDATE_EXAMCODE_SUCCESS,
                examCode: response.data
            })            
            if (payload.id == 0) {
                message.success('Exam code added successfully.');
            } else {
                message.success('Exam code updated successfully.');
            }

        } else {
            yield put({ type: SUBMIT_ERROR });
            message.error('Failed to add exam code!');
        }
    }
    catch (error) {
        yield put({ type: SUBMIT_ERROR });
        message.error('Failed to add exam code!');
    }
}

function* adminExamCodesWatcher() {
    yield takeLatest(FETCH_ALL_EXAMCODES, fetchAllExamCodes)
    yield takeLatest(ADD_UPDATE_EXAMCODE, addUpdateExamCode)

}

export default function* rootSaga() {
    yield all([
        adminExamCodesWatcher()
    ]);
}